export default {
  'page-title': 'E-Leave - Approver Calendar',
  title: 'Approver Calendar',
  'leave-type-legend': 'Leave type:',
  'status-legend': 'Status:',
  'detail-title': 'Leave Request Detail'
}
